import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Card, EmptyState } from "@/components/common";
import { StatusBadge } from "@/components/StatusBadge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { JobOpenings } from "@/components/JobOpenings";
import { fmtDate } from "@/lib/dates";

const STATUSES = ["Not Asked", "Not Interested", "Interested", "Sent to Recruiter", "Recruiter Assigned", "Interview Scheduled", "Interview Completed", "Offer Extended", "Offer Accepted", "Hired", "Declined", "Not Eligible"];

export default function Recruiting() {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/recruiting").then(({ data }) => setRows(data));
  useEffect(() => { load(); }, []);

  const update = async (r, status) => {
    await api.post("/recruiting", { ...r, student: undefined, status });
    toast.success("Updated"); load();
  };

  return (
    <div>
      <PageHeader title="Recruiting Pipeline" subtitle="Convert interns into employees" />
      <JobOpenings />
      <Card className="overflow-hidden">
        {rows.length === 0 ? <EmptyState text="No referrals yet." /> : (
          <div className="overflow-x-auto cc-scroll -m-5">
            <table className="w-full text-sm">
              <thead className="bg-zinc-50 text-zinc-500 text-xs uppercase">
                <tr><th className="text-left px-5 py-3">Student</th><th className="text-left px-5 py-3">Discipline</th><th className="text-left px-5 py-3">Graduation</th><th className="text-left px-5 py-3">Interested</th><th className="text-left px-5 py-3">Status</th></tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-t" data-testid={`recruit-${r.id}`}>
                    <td className="px-5 py-3 font-medium text-zinc-800">{r.student?.name || "—"}</td>
                    <td className="px-5 py-3"><span className="font-mono text-xs px-2 py-0.5 bg-zinc-100 rounded">{r.discipline}</span></td>
                    <td className="px-5 py-3 font-mono text-xs">{fmtDate(r.student?.graduation_date)}</td>
                    <td className="px-5 py-3">{r.interested ? <span className="text-cc-green text-xs font-medium">Yes</span> : "—"}</td>
                    <td className="px-5 py-3">
                      <Select value={r.status} onValueChange={(v) => update(r, v)}>
                        <SelectTrigger className="w-48 h-8" data-testid={`recruit-status-${r.id}`}><SelectValue /></SelectTrigger>
                        <SelectContent>{STATUSES.map((s) => <SelectItem key={s} value={s}>{s}</SelectItem>)}</SelectContent>
                      </Select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </div>
  );
}
